import React, { useCallback, useEffect, useState } from "react";
import SiteList from "./SiteList";
import { useSites } from "../../hooks/useSites";
import { useCodelist } from "../../hooks/useCodelist";
import FormFields from "./siteFields.json";
import { initialPaginationModelValues } from "../../constants/paginationConstants";
import { GridSortModel } from "@mui/x-data-grid-pro";
import { debounce } from "lodash";
import { useParams } from "react-router-dom";

const SitePage: React.FunctionComponent<any> = () => {
  const params = useParams();
  const [rowsCount, setRowsCount] = useState<number>(0);
  const [paginationModel, setPaginationModel] = useState(
    initialPaginationModelValues
  );
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "site_id", sort: "asc" },
  ]);
  const [filterVal, setFilterVal] = useState("");
  const { getAllSites, allSitesData, allSitesIsLoading, allSitesIsSuccess } =
    useSites();
  const [sitesList, setSitesList] = useState<any[]>([]);
  const handleSortModelChange = useCallback(
    debounce((model: GridSortModel) => {
      setSortModel(model);
    }, 300),
    []
  );
  const getAllSitesFunc = async (
    from: number,
    size: number,
    filterValue?: any
  ) => {
    await getAllSites({
      study_id: params?.study_id,
      from,
      size,
      value: filterValue &&  filterValue?.quickFilter ? filterValue?.quickFilter : "",
      sort_by: sortModel?.[0]?.field,
      sort_order: sortModel?.[0]?.sort,
      data:filterValue && filterValue?.advanceFilter 
    });
  };

  const { getCodelistData, codelistData } = useCodelist();

  useEffect(() => {
    getCodelistData({ data: { code_list_codes: FormFields.CODES } });
  }, []);

  useEffect(() => {
    if (codelistData) {
      FormFields.siteFields.map((obj) => {
        if (obj.name == "country") {
          obj.options = codelistData?.find(
            (item: any) => item.CNTRY?.length > 0
          ).CNTRY;
        }
        if (obj.name == "site_status") {
          obj.options = codelistData?.find(
            (item: any) => item.SITE_STATUS?.length > 0
          ).SITE_STATUS;
        }
      });
    }
  }, [codelistData]);

  useEffect(() => {
    if (paginationModel?.pageSize) {
      const { page, pageSize } = paginationModel;
      if (page * pageSize > rowsCount - 1) {
        getAllSitesFunc(0, pageSize, filterVal);
      } else {
        getAllSitesFunc(page * pageSize, pageSize, filterVal);
      }
    }
  }, [paginationModel, filterVal]);

  useEffect(() => {
    if (allSitesData && allSitesIsSuccess) {
      setRowsCount(allSitesData?.count);
      const data = allSitesData?.result?.map((ele: any) => {
        return {
          ...ele,
          id: ele?.site_id,
        };
      });
      setSitesList(data);
    } else if (allSitesData?.count == 0) {
      setRowsCount(0);
      setSitesList([]);
    }
  }, [allSitesData, allSitesIsSuccess]);

  return (
    <>
      <SiteList
        sitesList={sitesList}
        rowsCount={rowsCount}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        allSitesIsLoading={allSitesIsLoading}
        setFilterVal={setFilterVal}
        filterVal={filterVal}
        getAllSitesFunc={getAllSitesFunc}
        sortModel={sortModel}
        handleSortModelChange={handleSortModelChange}
        codelistData={codelistData}
      />
    </>
  );
};

export default SitePage;
